module.exports = __webpack_public_path__ + "poppins-v5-devanagari_latin-ext_latin-300.2b02853f306b110cc9e2.woff";


//////////////////
// WEBPACK FOOTER
// J:/Dev/Workspaces/NovaSingular/JulianaGimenez/angular/src/assets/fonts/Poppins/poppins-v5-devanagari_latin-ext_latin-300.woff
// module id = ../../../../../src/assets/fonts/Poppins/poppins-v5-devanagari_latin-ext_latin-300.woff
// module chunks = styles